import { render, staticRenderFns } from "./cancellationForm.vue?vue&type=template&id=510f1238"
import script from "./cancellationForm.vue?vue&type=script&lang=js"
export * from "./cancellationForm.vue?vue&type=script&lang=js"
import style0 from "./cancellationForm.vue?vue&type=style&index=0&id=510f1238&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports